import { Env, readFromEnv } from '@cinch-nx/environments'

export const VEHICLE_SEARCH_URL = `${readFromEnv(
  Env.SearchServiceUrl,
)}/vehicles`

export const AFFILIATE_VEHICLES_URL = `${readFromEnv(
  Env.SearchServiceUrl,
)}/affiliate-vehicles`
